import type { CostCenters } from "@/apis/gql/types";
import { useTenant } from "@/providers/session";
import { gql, useQuery } from "@apollo/client";

export const useGetAllCostCenters = () => {
  const { tenantId } = useTenant();

  const { data, error, loading, refetch } = useQuery(COST_CENTERS_QUERY, {
    variables: { tenantId },
  });

  return {
    costCenters: data?.costCenters as CostCenters[],
    errorCostCenters: error,
    loadingCostCenters: loading,
    refetchCostCenters: refetch,
  };
};

export const COST_CENTERS_QUERY = gql`
  query costCenters($tenantId: String!) {
    costCenters(tenantId: $tenantId) {
      costCenterId
      name
      description
      identifier
    }
  }
`;
